
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, GetTrialNotes, QuerySourceDatas, QuerySourceDatasResponse, Participant, MetadataEvent, MetadataEventForm, MetadataForm, MetadataFormVersion, MetadataItemGroup, MetadataItem, MetadataItemValue, GetMetadata } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<QuerySourceDatasResponse, QuerySourceDatasResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<QuerySourceDatasResponse, QuerySourceDatasResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QuerySourceDatasResponse, QuerySourceDatasResponse>) => ({
});

export const useSourceData = (trialId?: number, participantId?: number, studyEventOid?: string, studyEventRepeat?: number, caseReportFormOid?: string, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!trialId || !participantId) {
            return undefined;
        }

        return () => {
            return new QuerySourceDatas({ trialId, participantId, studyEventOid, studyEventRepeat, caseReportFormOid });
        }
    }, [trialId, participantId, studyEventOid, studyEventRepeat, caseReportFormOid]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useSourceData;